import { Check } from "lucide-react";
import { LANGS } from "@/components/sections/header/nav-config";

export default function LangDropdown({ lang, onPick }) {
  return (
    <div
      className="absolute right-0 mt-2 w-32 bg-white rounded-2xl shadow-xl border border-[var(--border)] py-1.5 z-[60]"
      data-testid="mobile-lang-dropdown"
    >
      {LANGS.map(({ code, label }) => {
        const isActive = lang === code;
        const cls = isActive
          ? "text-[var(--primary)] bg-[var(--bg)]"
          : "text-[var(--heading)] hover:bg-[var(--bg)]";
        return (
          <button
            key={code}
            onClick={() => onPick(code)}
            data-testid={`mobile-lang-pick-${code}`}
            className={`w-full px-3.5 py-3 min-h-[44px] flex items-center justify-between text-sm font-semibold transition ${cls}`}
          >
            <span>{label}</span>
            {isActive && (
              <Check className="w-4 h-4 text-[var(--accent)]" strokeWidth={2.5} />
            )}
          </button>
        );
      })}
    </div>
  );
}
